/** @format */

import { Table } from "antd";
import { usePencairanBos } from "hooks/HookBos/usePencairanBos";
import { useCallback, useEffect, useMemo } from "react";
import {
  columnsPengajuan,
  isJenjangValid,
  JENJANG_INVALID_MESSAGE,
} from "./Component/ColumnTable";
import ModalTanggalPencairan from "./Component/ModalTanggalPencairan";
import { useFormModal } from "hooks/useFormModal";
import moment from "moment";
import "moment/locale/id";
import notifAlert from "components/NotifAlert";

type contentPengajuanType = {
  auth: any;
  route: any;
  dataState: any;
};
export const ContentPengajuan = ({
  auth,
  route,
  dataState,
}: contentPengajuanType) => {
  const {
    loading,
    pengajuanSumberDanaBos,
    getDataPengajuan,
    updatePengajuanPenyaluran,
    deleteDataPencairan,
  } = usePencairanBos(auth);

  const { open, initialData, openWithInitialData, closeModal } = useFormModal();
  useEffect(() => {
    if (auth?.isTahun) {
      getDataPengajuan();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.isTahun]);

  const handleDelete = useCallback(
    async (values: any) => {
      if (!isJenjangValid(values?.jenjang)) {
        notifAlert({ type: "warning", description: JENJANG_INVALID_MESSAGE });
        return;
      }
      const payload = {
        tahun: parseInt(auth?.isTahun),
        tahap: parseInt(values?.tahapan),
        batch: parseInt(values?.batch),
        status: 2,
        jenjang: values?.jenjang,
      };
      const res = await deleteDataPencairan(payload, "pengajuan");
      if (res) {
        notifAlert({
          type: "success",
          description: "Penghapusan Data Madrasah Berhasil",
        });
      }
    },
    [auth?.isTahun, deleteDataPencairan],
  );

  const handlePencairan = useCallback(
    (values: any) => {
      openWithInitialData(values);
    },
    [openWithInitialData],
  );

  const columns = useMemo(() => {
    return columnsPengajuan(route, dataState, handlePencairan, handleDelete);
  }, [dataState, handleDelete, handlePencairan, route]);

  const handleSavePengajuan = useCallback(
    async (values: any) => {
      if (!isJenjangValid(initialData?.jenjang)) {
        notifAlert({ type: "warning", description: JENJANG_INVALID_MESSAGE });
        return;
      }
      const payload = {
        tahun: parseInt(auth?.isTahun),
        tahap: parseInt(initialData?.tahapan),
        batch: parseInt(initialData?.batch),
        start_tanggal_verifikasi: moment(
          initialData?.tanggal_mulai_verifikasi,
        ).format("YYYY-MM-DDT00:00:00"),
        end_tanggal_verifikasi: moment(
          initialData?.tanggal_akhir_verifikasi,
        ).format("YYYY-MM-DDT23:59:59"),
        tanggal_penyaluran: moment(values?.tanggalPencairan).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
        jenjang: initialData?.jenjang,
      };
      const res = await updatePengajuanPenyaluran(payload);
      if (res) {
        notifAlert({
          type: "success",
          description: "Data berhasil di Salurkan",
        });
        closeModal();
      }
    },
    [
      auth?.isTahun,
      closeModal,
      initialData?.batch,
      initialData?.jenjang,
      initialData?.tahapan,
      initialData?.tanggal_akhir_verifikasi,
      initialData?.tanggal_mulai_verifikasi,
      updatePengajuanPenyaluran,
    ],
  );

  return (
    <>
      <Table
        rowKey={(record) =>
          `re-${record?.batch}-${record?.tahapan}-${record?.jenjang}`
        }
        loading={loading}
        columns={columns}
        dataSource={pengajuanSumberDanaBos}
        bordered
      />
      <ModalTanggalPencairan
        loading={loading}
        data={initialData}
        openModal={open}
        handleClose={closeModal}
        title={"Pengajuan Pencairan BOS"}
        handleSave={handleSavePengajuan}
      />
    </>
  );
};
